import template from './objective.html'
import './objective.css'

export default {
  template,
  controller: function () { },
  controllerAs: 'objective',
  bindings: { data: '=' }
}
